import { lazy } from 'react';

export const AttributesHashtagsPage = lazy(() => import('./AttributesHashtagsPage'));
